import s from './BlogMagazine.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import SubHeader from '../../components/SubHeader/SubHeader';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from "react-helmet";

const blogs = [
  {
    id: 1,
    title: 'キュランダ観光ツアー ジェイさんツアーマガジン#01',
    date: '2019年12月13日',
    category: 'ジェイさんマガジン',
    comment: '1件のコメント',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/12/KDX_01_thum-1140x530.png',
    body: 'スワイプでマガジン形式で閲覧することができます。 キュランダ観光ツアー ケアンズの絶対外せない定番ツアー 日本人が忘れかけている、ゆったり時間を取り戻す旅 キュ',
    link: '/blog/magazine/num01',
    magazine: true,
    sale: false,
    world: false,
    info: false,
  },
  {
    id: 2,
    title: '大自然動物探検ツアー ジェイさんツアーマガジン#02',
    date: '2023年11月21日',
    category: 'ジェイさんマガジン',
    comment: '',
    img: 'https://dev.mightyaussie.com/wp-content/uploads/2019/12/ANML_01_thum-1140x530.png',
    body: 'スワイプでマガジン形式で閲覧することができます。 大自然動物探検ツアー 大人も子供も大満足✨ 動物園では見られない野生のワラビーや夜行性動物との触',
    link: 'blog/magazine/num02',
    magazine: true,
    sale: false,
    world: false,
    info: false,
  },
]
const breadcrumbs = [
  { label: 'ホーム ', link: '/' },
  { label: 'ジェイさんブログ', link: '/blog' },
  { label: 'ジェイさんマガジン' },
];


const BlogMagazine = () => {
  return (
    <>
    <Helmet>
    <title>ジェイさんマガジン - ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】</title>
    <meta property="og:title" content="ジェイさんマガジン - ケアンズの旅行やツアーを最安値で予約【ジェイさんツアー】" />
    <meta property="og:url" content={`${process.env.REACT_APP_URL}/blog/magazine`} />
    <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />
  </Helmet>
    <div className={s.root}>
    <SubHeader
      title="カテゴリー: ジェイさんマガジン"
      breadcrumbs={breadcrumbs}
    />
      <div className={s.flex}>
      <div className={s.blogContainer}>
    {blogs.map((blog) => (
      <a
        key={blog.id}
        href={blog.link}
        className={s.cardLinkWrapper}
        aria-label={blog.title}
      >
        <div className={s.card}>
          <div className={s.cardContent}>
            <h3 className={s.cardTitle}>{blog.title}</h3>
              <div className={s.cardMeta}>
                <span className={s.cardMetaItem}>
                <i className="fa fa-calendar"></i>{blog.date}
                </span>
                <span className={s.cardMetaItem}>
                <i className="fa fa-user"></i>ジェイさんツアー
                </span>
                {blog.magazine && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ジェイさんマガジン
                  </span>
                )}
                {blog.sale && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ツアーをお得に探す
                  </span>
                )}
                {blog.world && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>世界遺産の観光スポット
                  </span>
                )}
                {blog.info && (
                  <span className={s.cardMetaItem}>
                  <i className="fa fa-pencil"></i>ケアンズで快適に過ごすお得情報
                  </span>
                )}
              </div>
            <img src={blog.img} alt={blog.title} className={s.cardImage} />
            <p className={s.cardBody}>{blog.body.slice(0, 100)}...</p>
            <div className={s.center}><a className={s.button} href={blog.link}>続きを見る<i class="atbtn__icon atbtn__icon--right fa fa-long-arrow-right"></i></a></div>
          </div>
        </div>
      </a>
    ))}
  </div>
     <Aside/>
      </div>
    </div>
    </>
  );
}

export default BlogMagazine;
